import {HttpRenewTransformProjectOptions, httpRenewTransformProject} from '@/features/projects/http/projects.http'
import {ProjectSmall} from '@/features/projects/types'
import {MUTATION_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreRenewTransformProject = ({
    projectId,
    options
}: {
    projectId: string
    options?: UseMutationOptions<
        Omit<ProjectSmall, 'referringDoctor' | 'progressStatus'>, // todo: remove this omit once the backend is updated
        AxiosError<ErrorResponseData>,
        HttpRenewTransformProjectOptions['payload']
    >
}) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.RENEW_TRANSFORM_PROJECT, projectId],
        mutationFn: payload => httpRenewTransformProject({urlParams: {projectId}, payload})
    })
}
